import { jsx as _jsx } from "react/jsx-runtime";
import { RoutePointBase } from "@/components/RouteForm2/createRoutePointsTransferOptions";
export class Base2RoutePointTransferData {
    adapt(source) {
        const data = {
            idRoute: null,
            idOrder: null,
            idBase: source.id, // Base identifier for route point selection
            orderIndex: 0,
            plannedArrivalTime: null,
            plannedDepartureTime: null,
            actualArrivalTime: null,
            actualDepartureTime: null,
            expectedArrivalTime: null,
            expectedDepartureTime: null,
            addressInfo: source.addressInfo,
        };
        return {
            key: source.id,
            label: source.addressInfo.getAddress() || "Адрес не указан",
            data,
            renderLabel: () => _jsx(RoutePointBase, { point: data, base: source }),
        };
    }
    adaptMany(sources) {
        return sources.map((source) => this.adapt(source));
    }
}
export class Base2RoutePointCreateData {
    adapt(source) {
        const data = {
            idRoute: null,
            idOrder: null,
            idBase: source.id, // Base identifier for route point selection
            orderIndex: 0,
            plannedArrivalTime: null,
            plannedDepartureTime: null,
            actualArrivalTime: null,
            actualDepartureTime: null,
            expectedArrivalTime: null,
            expectedDepartureTime: null,
            addressInfo: source.addressInfo,
        };
        return data;
    }
    adaptMany(sources) {
        return sources.map((source) => this.adapt(source));
    }
}
